@if (visibleTeasers()?.length !== 0) {
  <div class="row">
    <div class="col-lg-12 mt-5 mb-5">
      <carousel>
        @for (teaser of visibleTeasers(); track teaser) {
          <slide>
            <img [alt]="teaser.page" [src]="teaser.teaserSrc" style="width: 100%" />
          </slide>
        }
      </carousel>
    </div>
  </div>
}
